import React from "react"

import { BasicContact } from "@/app/pages/contactDirectory/interface"

type IProfileCardProps = BasicContact & {
  onClickModalButton: (type: "open" | "close") => void
}

const ProfileCard = (props: IProfileCardProps) => {
	const {
		familyName,
		givenName,
		title,
		url,
    onClickModalButton,
	} = props;

	// const [showModal, setShowModal] = useState(false);

	// const onClickModalButton = (type: "close" | "open") => setShowModal(type === "open");

	return (
		<div className="contact-card">
			<div className="name-title-wrap">
				<div
					className="overflow-text-ellipsis link-with-underline"
					title={`${givenName} ${familyName}`}>
					<a href={url}>
						{givenName}

						&nbsp;
						{familyName}
					</a>
				</div>

				<div
					className="overflow-text-ellipsis"
					title={title}>
					{title}
				</div>
			</div>

			<div>
				<img className="email-img" />

				<a
					className="ContactProfileMoversAndShakersFragmentComponentEmailLink email-link link-with-underline suppress-ms-ext-icon"
					onClick={() => onClickModalButton("open")}>
					Email
				</a>

				<img className="phone-img" />

				<a
					className="ContactProfileMoversAndShakersFragmentComponentPhoneLink link-with-underline suppress-ms-ext-icon"
					onClick={() => onClickModalButton("open")}>
					Phone
				</a>
			</div>
{/* 
			<HooversModal
				onClickModalButton={onClickModalButton}
				showModal={showModal} /> */}
		</div>
	);
};

export default ProfileCard